import Cookies from 'js-cookie'
import packageJson from '../package.json'

const apiUrlToWebSocketUrl = (apiUrl: string) => {
    const url = new URL(apiUrl)
    return `${url.protocol === 'http:' ? 'ws' : 'wss'}://${url.host}`
}

const localhost = false
const version = '3.3.3'
const proxy = null
const clientUrl = 'https://charge.sk'
const apiUrl = 'https://api.charge.sk/api/'
const chargeTenantId = '9b671b08-c0a7-4ac9-82db-7275e7d6893c'
const appKey = 'd572601b-0651-47b8-b53c-832fce02a8e1'

export const config = localhost
    ? {
          api: '/api/',
          version: 'dev',
          websocket: 'wss://localhost:44374',
          proxy: packageJson.proxy,
          client: 'http://localhost:3000',
          chargeTenantId: '8301fe71-bc7e-49ef-b97b-a16e2744aad9',
          appKey: 'd572601b-0651-47b8-b53c-832fce02a8e1',
      }
    : {
          api: apiUrl,
          version: version,
          client: clientUrl,
          websocket: apiUrlToWebSocketUrl(apiUrl),
          proxy: proxy,
          chargeTenantId: chargeTenantId,
          appKey: appKey
      }

export const getToken = () => {
    return Cookies.get('clientToken')
}

export const setToken = (token: string) => {
    Cookies.set('clientToken', token)
}

export const removeToken = () => {
    Cookies.remove('clientToken')
}

export const getDefaultLanguage = () => {
    return Cookies.get('defaultLanguage')
}

export const setDefaultLanguage = (defaultLanguage: string) => {
    Cookies.set('defaultLanguage', defaultLanguage)
    return defaultLanguage
}
